import { render, staticRenderFns } from "./NodeForm.vue?vue&type=template&id=5251f748"
import script from "./NodeForm.vue?vue&type=script&lang=js"
export * from "./NodeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5251f748')) {
      api.createRecord('5251f748', component.options)
    } else {
      api.reload('5251f748', component.options)
    }
    module.hot.accept("./NodeForm.vue?vue&type=template&id=5251f748", function () {
      api.rerender('5251f748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartForm/NodeForm.vue"
export default component.exports